// extracted by mini-css-extract-plugin
export default {"regionPosition":"GoTq3","char":"MjMtV","link":"ChSFO"};